export default {
    url: '',
    template: '<user-employee-list classifiers="vm.classifiers"/>',
    controller (classifiers) {
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/employee/list/index.js